import { useCheckPreferences } from "./hooks/useCheckPreferences";
import { useCheckExternalMessages } from "./hooks/useCheckExternalMessages";
import { useWindowHistoryByMouse } from "./hooks/useWindowHistoryByMouse";
import { useHideAllMenus } from "./hooks/useHideAllMenus";
import { useGeoBlockedPage } from "./hooks/useGeoBlockedPage";
import { useTrackPWA } from "./hooks/useTrackPWA";
import { useResetSearchTag } from "./hooks/useResetSearchTag";
import { useHeaderScroll } from "./hooks/useHeaderScroll";
import { useDetectGeolocation } from "./hooks/useDetectGeolocation";
import { useTrackCookieConsent } from "./hooks/useTrackCookieConsent";
import { useGoCtrl } from "./hooks/useGoCtrl";
import { useAppStyles } from "./hooks/useAppStyles";
import { useGetUserData } from "./hooks/useGetUserData";
import { useInitDocumentTitle } from "./hooks/useInitDocumentTitle";
import { useTrackVisit } from "./hooks/useTrackVisit";
import { useFullScreen } from "./hooks/useFullScreen";
import { useTrackUser } from "./hooks/useTrackUser";
import { useOrientation } from "./hooks/useOrientation";
import { useScroll } from "./hooks/useScroll";
import { useGTM } from "./hooks/useGTM";
import { useCensor } from "./hooks/useCensor";
import { useVerification } from "./hooks/useVerification";
import { useFeedModules } from "./hooks/useFeedModules";
import { useAgeDisclaimer } from "./hooks/useAgeDisclaimer";

export const AppHooks = () => {
  useGetUserData();
  useCheckPreferences();
  useCheckExternalMessages();
  useDetectGeolocation();
  useGeoBlockedPage();
  useAgeDisclaimer();

  useTrackVisit();
  useAppStyles();
  useWindowHistoryByMouse();
  useInitDocumentTitle();
  useHideAllMenus();
  useFullScreen();
  useTrackUser();
  useOrientation();
  useTrackPWA();
  useResetSearchTag();

  useHeaderScroll();
  useScroll();

  useTrackCookieConsent();
  useGoCtrl();
  useGTM();

  useCensor();
  useVerification();

  useFeedModules();

  return null;
};
